var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.5 7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.00 2.50 C 5.00 3.88 3.88 5.00 2.50 5.00 C 1.12 5.00 0.00 3.88 0.00 2.50 C 0.00 1.12 1.12 0.00 2.50 0.00 C 3.88 0.00 5.00 1.12 5.00 2.50 Z",
    fill: "none",
    stroke: "#94A3B8",
    strokeWidth: 1.6666666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0483332 4.1666665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.00 5.83 C 1.06 2.45 4.22 0.00 7.95 0.00 C 11.68 0.00 14.84 2.45 15.90 5.83 C 14.84 9.21 11.68 11.67 7.95 11.67 C 4.22 11.67 1.06 9.21 0.00 5.83 Z",
    fill: "none",
    stroke: "#94A3B8",
    strokeWidth: 1.6666666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.70cf300bde6efa549aacb659b8aba7bb.svg";
export { ForwardRef as ReactComponent };